import React, { useContext, useEffect, useState, useRef } from 'react';
  declare global {
    interface Window {
        Trustpilot:any;
    }
}
const TrustPilotReview = () => {
  const ref = useRef(null);
  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <div
    ref={ref}
     className="trustpilot-widget"
      data-locale="en-US"
       data-template-id="5613c9cde69ddc09340c6beb"
        data-businessunit-id="5d485c0eaf4c150001452791"
         data-style-height="100%"
          data-style-width="100%"
           data-theme="light">
    <a href="https://www.trustpilot.com/review/pdfsimpli.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
  );
};
export default TrustPilotReview;